import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetProductionCategoriesQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ProductionCategoryDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ProductionCategoryDocumentSortInput> | Types.ProductionCategoryDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetProductionCategoriesQuery = { __typename?: 'Query', productionCategories?: { __typename?: 'ProductionCategoriesConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionCategoryDocument', id: string, tenantId: string, productionCategoryId: string, code: string, label?: string | null, eaches: number, laborCostPerUnit?: number | null, laborCostEffectiveDate?: Types.TDateISO | null, unitsPerPole?: number | null, productionSpaceCategoryCode: string, productionSpaceCategoryId: string, status: Types.ProductionCategoryStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, spaceEventNames: string, materialEventNames: string, taskEventNames: string, materialEventAttachments: Array<{ __typename?: 'ProductionEventAttachmentDocumentData', eventId: string, defaultAssignedTo?: string | null }>, spaceEventAttachments: Array<{ __typename?: 'ProductionEventAttachmentDocumentData', eventId: string, defaultAssignedTo?: string | null }>, taskEventAttachments: Array<{ __typename?: 'ProductionEventAttachmentDocumentData', eventId: string, defaultAssignedTo?: string | null }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetProductionCategoryQueryVariables = Types.Exact<{
  productionCategoryId: Types.Scalars['String']['input'];
}>;


export type GetProductionCategoryQuery = { __typename?: 'Query', productionCategory?: { __typename?: 'ProductionCategoryStateData', productionCategoryId: string, tenantId: string, code: string, label?: string | null, eaches: number, laborCostPerUnit?: number | null, laborCostEffectiveDate?: Types.TDateISO | null, unitsPerPole?: number | null, status: Types.ProductionCategoryStatus, productionTaskEventIds: Array<string>, productionSpaceEventIds: Array<string>, productionSpaceCategoryId: string, productionMaterialEventIds: Array<string>, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null };

export type ProductionCategorySummaryFragment = { __typename?: 'ProductionCategoryDocument', id: string, tenantId: string, productionCategoryId: string, code: string, label?: string | null, eaches: number, laborCostPerUnit?: number | null, laborCostEffectiveDate?: Types.TDateISO | null, unitsPerPole?: number | null, productionSpaceCategoryCode: string, productionSpaceCategoryId: string, status: Types.ProductionCategoryStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, spaceEventNames: string, materialEventNames: string, taskEventNames: string, materialEventAttachments: Array<{ __typename?: 'ProductionEventAttachmentDocumentData', eventId: string, defaultAssignedTo?: string | null }>, spaceEventAttachments: Array<{ __typename?: 'ProductionEventAttachmentDocumentData', eventId: string, defaultAssignedTo?: string | null }>, taskEventAttachments: Array<{ __typename?: 'ProductionEventAttachmentDocumentData', eventId: string, defaultAssignedTo?: string | null }> };

export type ProductionCategoryDataFragment = { __typename?: 'ProductionCategoryStateData', productionCategoryId: string, tenantId: string, code: string, label?: string | null, eaches: number, laborCostPerUnit?: number | null, laborCostEffectiveDate?: Types.TDateISO | null, unitsPerPole?: number | null, status: Types.ProductionCategoryStatus, productionTaskEventIds: Array<string>, productionSpaceEventIds: Array<string>, productionSpaceCategoryId: string, productionMaterialEventIds: Array<string>, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string };

export type GetProductionCategoryOptionsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.ProductionCategoryDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ProductionCategoryDocumentSortInput> | Types.ProductionCategoryDocumentSortInput>;
}>;


export type GetProductionCategoryOptionsQuery = { __typename?: 'Query', productionCategories?: { __typename?: 'ProductionCategoriesConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionCategoryDocument', productionCategoryId: string, code: string, eaches: number }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export const ProductionCategorySummaryFragmentDoc = new TypedDocumentString(`
    fragment ProductionCategorySummary on ProductionCategoryDocument {
  id
  tenantId
  productionCategoryId
  code
  label
  eaches
  materialEventAttachments {
    eventId
    defaultAssignedTo
  }
  laborCostPerUnit
  laborCostEffectiveDate
  unitsPerPole
  productionSpaceCategoryCode
  productionSpaceCategoryId
  spaceEventAttachments {
    eventId
    defaultAssignedTo
  }
  status
  taskEventAttachments {
    eventId
    defaultAssignedTo
  }
  createdAt
  createdBy
  updatedAt
  updatedBy
  spaceEventNames
  materialEventNames
  taskEventNames
  materialEventAttachments {
    eventId
    defaultAssignedTo
  }
  spaceEventAttachments {
    eventId
    defaultAssignedTo
  }
  taskEventAttachments {
    eventId
    defaultAssignedTo
  }
}
    `, {"fragmentName":"ProductionCategorySummary"});
export const ProductionCategoryDataFragmentDoc = new TypedDocumentString(`
    fragment ProductionCategoryData on ProductionCategoryStateData {
  productionCategoryId
  tenantId
  code
  label
  eaches
  laborCostPerUnit
  laborCostEffectiveDate
  unitsPerPole
  status
  productionTaskEventIds
  productionSpaceEventIds
  productionSpaceCategoryId
  productionMaterialEventIds
  createdAt
  createdBy
  updatedAt
  updatedBy
}
    `, {"fragmentName":"ProductionCategoryData"});
export const GetProductionCategoriesDocument = new TypedDocumentString(`
    query GetProductionCategories($where: ProductionCategoryDocumentFilterInput, $order: [ProductionCategoryDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  productionCategories(
    where: $where
    order: $order
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    nodes {
      ...ProductionCategorySummary
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment ProductionCategorySummary on ProductionCategoryDocument {
  id
  tenantId
  productionCategoryId
  code
  label
  eaches
  materialEventAttachments {
    eventId
    defaultAssignedTo
  }
  laborCostPerUnit
  laborCostEffectiveDate
  unitsPerPole
  productionSpaceCategoryCode
  productionSpaceCategoryId
  spaceEventAttachments {
    eventId
    defaultAssignedTo
  }
  status
  taskEventAttachments {
    eventId
    defaultAssignedTo
  }
  createdAt
  createdBy
  updatedAt
  updatedBy
  spaceEventNames
  materialEventNames
  taskEventNames
  materialEventAttachments {
    eventId
    defaultAssignedTo
  }
  spaceEventAttachments {
    eventId
    defaultAssignedTo
  }
  taskEventAttachments {
    eventId
    defaultAssignedTo
  }
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetProductionCategoryDocument = new TypedDocumentString(`
    query GetProductionCategory($productionCategoryId: String!) {
  productionCategory(productionCategoryId: $productionCategoryId) {
    ...ProductionCategoryData
  }
}
    fragment ProductionCategoryData on ProductionCategoryStateData {
  productionCategoryId
  tenantId
  code
  label
  eaches
  laborCostPerUnit
  laborCostEffectiveDate
  unitsPerPole
  status
  productionTaskEventIds
  productionSpaceEventIds
  productionSpaceCategoryId
  productionMaterialEventIds
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const GetProductionCategoryOptionsDocument = new TypedDocumentString(`
    query GetProductionCategoryOptions($first: Int, $after: String, $where: ProductionCategoryDocumentFilterInput, $order: [ProductionCategoryDocumentSortInput!]) {
  productionCategories(first: $first, after: $after, where: $where, order: $order) {
    nodes {
      productionCategoryId
      code
      eaches
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetProductionCategories: build.query<GetProductionCategoriesQuery, GetProductionCategoriesQueryVariables | void>({
      query: (variables) => ({ document: GetProductionCategoriesDocument, variables })
    }),
    GetProductionCategory: build.query<GetProductionCategoryQuery, GetProductionCategoryQueryVariables>({
      query: (variables) => ({ document: GetProductionCategoryDocument, variables })
    }),
    GetProductionCategoryOptions: build.query<GetProductionCategoryOptionsQuery, GetProductionCategoryOptionsQueryVariables | void>({
      query: (variables) => ({ document: GetProductionCategoryOptionsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetProductionCategoriesQuery, useLazyGetProductionCategoriesQuery, useGetProductionCategoryQuery, useLazyGetProductionCategoryQuery, useGetProductionCategoryOptionsQuery, useLazyGetProductionCategoryOptionsQuery } = injectedRtkApi;
